import React from "react";
import { MainButton } from "@twa-dev/sdk/react";

import { isTelegramMiniApp } from "../utils/platform";
import "./PlatformMainButton.css";

/**
 * Главная кнопка экрана.
 *
 * В Telegram её рисует сам клиент внизу окна — это системная MainButton.
 * В браузере такой кнопки не существует вовсе, и без замены экраны займа,
 * вывода, премиума и покупки сертификата остались бы без единственной кнопки
 * действия: форма есть, отправить нечем.
 *
 * Поэтому в вебе рисуем свою — закреплённую внизу, с тем же поведением:
 * тот же текст, тот же обработчик, то же состояние загрузки.
 */

interface Props {
  text: string;
  onClick: () => void;
  /** Кнопка неактивна. */
  disabled?: boolean;
  /** Идёт операция: в Telegram это крутилка внутри кнопки. */
  progress?: boolean;
}

const PlatformMainButton: React.FC<Props> = ({
  text,
  onClick,
  disabled = false,
  progress = false,
}) => {
  if (isTelegramMiniApp) {
    return (
      <MainButton
        text={text}
        onClick={onClick}
        disabled={disabled}
        progress={progress}
      />
    );
  }

  return (
    <>
      {/* Кнопка закреплена поверх контента, поэтому под ним нужен запас,
          иначе она перекрывает последний блок страницы. */}
      <div className="web-main-button-spacer" aria-hidden="true" />
      <div className="web-main-button-bar">
        <button
          type="button"
          className="web-main-button"
          onClick={onClick}
          disabled={disabled || progress}
        >
          {progress ? <span className="web-main-button-spinner" /> : null}
          {text}
        </button>
      </div>
    </>
  );
};

export default PlatformMainButton;
